import selfCardService from "@/apis/selfCard/index.js";
import { getSelfCardUserInfo } from "@/models/selfCardUser";

export default {
  data() {
    return {
      currentUserInfo: {},
      selfCardEnum: {},
    };
  },
  async created() {
    // 获取用户信息
    const userInfo = await getSelfCardUserInfo();
    this.currentUserInfo = userInfo;
    this.getSelfCardEnum();
  },
  methods: {
    getSelfCardEnum() {
      selfCardService.selfCardEnums().then((res) => {
        this.selfCardEnum = res;
      });
    },
  },
};
